import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type SendRecoveryCodeOperation = paths['/executor_web/recovery/send']['post'];

export type SendRecoveryCodeRequestBody = NonNullable<
	NonNullable<SendRecoveryCodeOperation['requestBody']>['content']['application/json']
>;
export interface SendRecoveryCodeRequest extends SendRecoveryCodeRequestBody {
	token: string;
}
export type SendRecoveryCodeResponse = SendRecoveryCodeOperation['responses'][200]['content']['application/json'];
export type SendRecoveryCodeErrorResponse = SendRecoveryCodeOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/recovery/send` — см. `paths['/executor_web/recovery/send']` в auth swagger */
export function sendRecoveryCode(request: SendRecoveryCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<SendRecoveryCodeResponse>('recovery/send', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
